import React, { useRef } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Button from '../../components/Button/Button';

const CustomFileUploadButton = ({
  label = 'Upload Files',
  onChange,
  multiple = true,
  accept,
  icon = <CloudUploadIcon />,
  bgColor,
  textColor,
  fontSize,
  disabled = false,
}) => {
  const inputRef = useRef(null);

  const handleButtonClick = () => {
    if (!disabled && inputRef.current) inputRef.current.click();
  };

  const handleInputChange = (e) => {
    const files = e.target.files;
    if (onChange) onChange(files);
    e.target.value = "";
  };

  return (
    <>
      <input
        type="file"
        ref={inputRef}
        style={{ display: 'none' }}
        multiple={multiple}
        accept={accept}
        onChange={handleInputChange}
      />

      <Button
      type="button"
        onClick={handleButtonClick}
        startIcon={icon}
        bgColor={bgColor}
        textColor={textColor}
        fontSize={fontSize}
        disabled={disabled}
        sx={{
          textTransform: 'capitalize',
          borderRadius: 6,
          px: 2,
          // borderColor: 'divider',
        }}
      >
        {label}
      </Button>
    </>
  );
};

export default CustomFileUploadButton;
